// extracted by mini-css-extract-plugin
module.exports = {"base":"MultiCanvas_base__3DAb2","innerBase":"MultiCanvas_innerBase__TUjBD"};